import { error, finish } from '../../../modules/liabilities/actions/get';

export function request(dispatch, {id, eventId}) {
    $appState.trpcClient.getSinglesLiabilities({ eventId: eventId, marketId: id }).then(
        liabilities => {
            const data = Object.assign(liabilities, { eventId });
            dispatch(finish(id, data));
        },
        errors => dispatch(error(id, errors))
    );
}
